import { AssignmentStatusType, AssignmentType } from '../../type';

export enum StudentAssignmentOrderByType {
  /** 최신과제순 (기본값 - 배정 최신순) */
  LATEST = 'LATEST',
  /** 오래된과제순 */
  OLDEST = 'OLDEST',
  /** 남은날짜순 (마감 임박 우선, 마감일 없는 과제는 마지막) */
  REMAIN_DAYS = 'REMAIN_DAYS',
}

export type AssignmentCategory =
  | 'NONE'
  | 'JEBSON'
  | 'RECITATION'
  | 'WMW'
  | 'HFHJ';

export type StudentAssignmentItem = {
  todoId: number;
  type: AssignmentType;
  book: string;
  lesson: string;
  title: string;
  progress: number;
  status: AssignmentStatusType;
  dueDate: string;
  completedDate: string | null;
  isUrgent: boolean;
  link: string;
};

export type StudentProgressBookSubjectLesson = {
  lesson: string;
  progress: number;
  status: AssignmentStatusType;
  title: string;
  voucherType: AssignmentType;
  link: string | null;
};

export type StudentProgressBookSubject = {
  completedCount: number;
  lessons: StudentProgressBookSubjectLesson[];
  subjectCode: string;
  subjectName: string;
  totalLessons: number;
  voucherType: AssignmentType;
};

export type StudentProgressBook = {
  id: string;
  book: string;
  progress: number;
  status: AssignmentStatusType;
  subjects: StudentProgressBookSubject[];
};

export type StudentProgressSubject = {
  type: AssignmentType;
  totalAssignments: number;
  completedCount: number;
  avgProgress: number;
};

export enum RecitationBookStatusType {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  ATTEMPTED = 'ATTEMPTED',
  NONE = 'NONE',
}

export type StudentProgressRecitationBook = {
  book: number;
  bookName: string;
  status: RecitationBookStatusType;
  passDate: string | null;
  todoId: number;
};

export type StudentProgressRecitationLevel = {
  level: number;
  books: StudentProgressRecitationBook[];
};

export type StudentProgress = {
  books: StudentProgressBook[];
  subjects: StudentProgressSubject[];
  totalAssignments: number;
  completedCount: number;
  overallProgress: number;
  lastActivityAt: string;
  totalDalant: number;
  recitationLevels: StudentProgressRecitationLevel[];
  dalantCharacter: {
    imageUrl: string;
    level: number;
    levelName: string | null;
    nextLevelAt: number;
    totalEarned: number;
  };
};

export enum AssignmentKindType {
  GENERAL = 'GENERAL', // 일반 과제
  TEST = 'TEST', // 젭스온 테스트(title에 Test 포함)
  AI_RECITATION_EXAM = 'AI_RECITATION_EXAM', // 젭스 AI 인증제 응시
  UNSUPPORTED = 'UNSUPPORTED', // 미지원(구 인증제 등)
}

export type AttemptInfo = {
  todoType: AssignmentType;
  kind: AssignmentKindType;
  attemptCount: number | null;
  attemptLimit: number | null;
};

export type StudentAssignmentItemWithAttempt = StudentAssignmentItem & {
  attemptCount?: number;
  attemptLimit?: number;
};
